// The eventHub is a global event communication hub for VueJS
// It's against best practices to use global events for your architecture
// But for pragmatic reasons, we'll use it as sparsely as possible when we need to communicate between otherwise unrelated component_params

// Usage:
//
//   1/ Register for event notifications:
//      window.eventHub.$on('eventName', (params) => { ... })
//
//   2/ Dispatch event:
//      window.eventHub.$emit('eventName', params)

// To prevent naming collisions and to keep us from abusing this power,
// List all events here

//   - 'openSidepane'
//   - 'sidepaneFixedChanged'
//   - 'fixSidepane'

//   - 'scrollToElement'
//   - 'refreshCommunicationData'
//   - 'resetCommunicationData'
//   - 'resetNotificationCount'
//   - 'resetCommunicationFilter'
//   - 'interactive-report-communication-opened'

//     Workflows#show screen
//   - 'workflows-filter-selected'
//   - 'workflows-filter-unselected'
//   - 'workflows-filter-reset'

//     Changelog banner
//   - 'updateChangelog'

import mitt from 'mitt'
import { SilverfinEvents } from '@app/types'

import environment from '@app/utils/environment'

const emitter = mitt<SilverfinEvents>()

const $devEmit: typeof window.eventHub.$emit = (
  ...args: Parameters<typeof emitter.emit>
) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [eventName, ...rest] = args

  console.log(`EVENT HUB: ${eventName}(${rest.toString()})`)

  emitter.emit.apply(this, args)
}

const baseEventHub = {
  $on: emitter.on.bind(emitter),
  $off: emitter.off.bind(emitter),
  $emit:
    environment.__DEV__ && !environment.__TEST__
      ? $devEmit
      : emitter.emit.bind(emitter),
}

window.eventHub = baseEventHub
